// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"ffbdf916","198":"2c46df70","212":"2760cf35","326":"dbeb346b","421":"05697a18","458":"4cca91f5","544":"f77e04f3"}[chunkId] + ".chunk.js";
};